import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/lib/i18n";
import { enableWebPush, disableWebPush, pushStatus } from "@/lib/push";

export default function PushCard() {
  const { t } = useLang();
  const [state, setState] = useState("checking");
  const load = () => pushStatus().then(setState).catch(() => setState("unsupported"));
  useEffect(() => { load(); }, []);
  const enable = async () => {
    try { await enableWebPush(); setState("on"); toast.success(t("dash.push_on")); }
    catch (e) { toast.error(e.message || t("dash.toast_error")); load(); }
  };
  const disable = async () => {
    try { await disableWebPush(); setState("off"); toast.success(t("dash.push_off")); }
    catch { toast.error(t("dash.toast_error")); }
  };
  const badge = { on: "bg-sage text-white", off: "bg-muted text-muted-foreground", denied: "bg-destructive/10 text-destructive", unsupported: "bg-muted text-muted-foreground", checking: "bg-muted text-muted-foreground" }[state];
  const label = { on: t("dash.push_on"), off: t("dash.push_off"), denied: t("dash.push_denied"), unsupported: "N/A", checking: "…" }[state];
  return (
    <div className="border border-border rounded-lg p-5 bg-card" data-testid="push-card">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2"><Bell className="w-4 h-4 text-sage"/><span className="uppercase tracking-[0.2em] text-[10px] text-muted-foreground">{t("dash.push_title")}</span></div>
        <span className={`text-xs px-2 py-1 rounded-full ${badge}`} data-testid="push-status">{label}</span>
      </div>
      <p className="text-xs text-muted-foreground mb-4">{t("dash.push_hint")}</p>
      {state === "on" ? (
        <Button size="sm" variant="outline" onClick={disable} className="w-full lift" data-testid="push-disable-btn">{t("dash.push_disable")}</Button>
      ) : (
        <Button size="sm" onClick={enable} disabled={state === "unsupported" || state === "denied"} className="w-full bg-primary text-primary-foreground hover:bg-primary/90 lift" data-testid="push-enable-btn">{t("dash.push_enable")}</Button>
      )}
    </div>
  );
}
